export default __webpack_public_path__ + "static/media/wsb-header-new.fc322334.png";